import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useScheduleDepositMutation = () => {
  const branchId = useBranchId();

  const { t } = useTranslation("");
  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.update"));
    },
    mutationFn: ({
      item_id,
      account_id,
      partial_deposit,
    }: {
      item_id: number;
      account_id: string;
      partial_deposit: string;
    }) =>
      patch(
        `/internal/secure/pos/v1/personnel/add/partial/deposit/${branchId}/${item_id}/${account_id}`,
        { partial_deposit }
      ),
  });
  return mutation;
};

export default useScheduleDepositMutation;
